__turbopack_context__.v({
  "actions": "job-details-card-module__aiOKXq__actions",
  "application_disabled": "job-details-card-module__aiOKXq__application_disabled",
  "benefits": "job-details-card-module__aiOKXq__benefits",
  "benefits_list": "job-details-card-module__aiOKXq__benefits_list",
  "button_container": "job-details-card-module__aiOKXq__button_container",
  "company_location": "job-details-card-module__aiOKXq__company_location",
  "company_name": "job-details-card-module__aiOKXq__company_name",
  "details": "job-details-card-module__aiOKXq__details",
  "header": "job-details-card-module__aiOKXq__header",
  "img": "job-details-card-module__aiOKXq__img",
  "job_company_location": "job-details-card-module__aiOKXq__job_company_location",
  "job_details_card": "job-details-card-module__aiOKXq__job_details_card",
  "link_details": "job-details-card-module__aiOKXq__link_details",
  "location": "job-details-card-module__aiOKXq__location",
  "modal_deficiency": "job-details-card-module__aiOKXq__modal_deficiency",
  "pcd_icon": "job-details-card-module__aiOKXq__pcd_icon",
  "requirements": "job-details-card-module__aiOKXq__requirements",
  "row": "job-details-card-module__aiOKXq__row",
  "title": "job-details-card-module__aiOKXq__title",
  "ways_of_contact_container": "job-details-card-module__aiOKXq__ways_of_contact_container",
});
